// Removed Button, Input imports
import { API } from 'aws-amplify'
import get from 'lodash/get'
// Added CBButton, CBInput imports
import { CBButton, CBInput } from '../../core/components/cbd';
import React, { useEffect, useState } from 'react'
import SyncItem from "./SyncItem"


const BoomerScanBridgeList = ({ initialBridges, userEmail, theme, pageLimit = 100, accounts }) => {
    const [bridges, setBridges] = useState(initialBridges);
    const [moreBridges, setMoreBridges] = useState(initialBridges.length === pageLimit)
    const [filterBridges, setFilterBridges] = useState(initialBridges);
    
    useEffect(() => {
        setMoreBridges(bridges.length % pageLimit === 0);
        
    }, [bridges]);

    async function loadNewBridgePage() {
        //get last key. 'calendarAccountId' for accounts. 'id' for bridge/sync
        const lastKey = get(bridges.at(-1), ['bridge', 'id']) || null;

        // console.log(bridges)
        debugger;
        const parameters = {
            email: userEmail,
            limit: pageLimit,
            exclusiveStartIdString: lastKey,
            action: 'getBridgePage'
        }
        try {
            var responseBridgeInfo = await API.get('scan', '/scan', {
                queryStringParameters: parameters,
            })
            const newBridgePage = get(responseBridgeInfo, 'results.bridges') || [];
            if (newBridgePage.length) {
                setFilterBridges([...bridges, ...newBridgePage]);
                setBridges([...bridges, ...newBridgePage]);
            } else {
                setMoreBridges(false);
            }
        } catch (ex) {
            alert('Error: getting new accounts page')
            // console.log(ex.message);
        } finally {

        }
    }

    return (<div>Syncs {bridges && bridges && <>{bridges.length} </>}:
    
    <div className="mt-4 mb-4 w-[600px] ">
        <label className="block text-sm font-medium text-gray-700 mb-1 container">Search:</label> {/* Added label */}
        {/* Replaced Input with CBInput */}
        <CBInput
            placeholder="search syncs by account/calendar ID" // Updated placeholder
            // allowClear - CBInput might not have this prop, handle clearing manually if needed
            onChange={val => { // Adapt onChange
                if(!val) {

                } else
                if(val == '') {
                    setFilterBridges(bridges)
                } else {
                    const lowerVal = val.toLowerCase();
                    setFilterBridges(bridges.filter(b => {
                        return b.bridge.sourceCalendarAccountId.toLowerCase().includes(lowerVal) ||
                               b.bridge.destCalendarAccountId.toLowerCase().includes(lowerVal) ||
                               b.bridge.sourceCalendarId.toLowerCase().includes(lowerVal) ||
                               b.bridge.destCalendarId.toLowerCase().includes(lowerVal)
                    }))
                }
            }}
        />
    </div>
    {filterBridges && filterBridges.map(({ bridge, pushSubscriptionStatus }) => (
        <SyncItem
            key={bridge.id} // Added key prop
            bridge={bridge}
            pushSubscriptionStatus={pushSubscriptionStatus}
            theme={theme}
            accounts={accounts}
            />
    ))}
    {/* Replaced Button with CBButton */}
    {moreBridges && <CBButton onClick={() => {
        loadNewBridgePage();
    }}>Load More Bridges</CBButton>}
</div>);
}

export default BoomerScanBridgeList;